'use client';

import { createContext } from 'react';

import { Tables } from '@kit/supabase/database';
import { JWTUserData } from '@kit/supabase/types';

interface UserWorkspace {
  accounts: Array<{
    label: string | null;
    value: string | null;
    image: string | null;
  }>;

  workspace: {
    id: string | null;
    name: string | null;
    picture_url: string | null;
    subscription_status: Tables<'subscriptions'>['status'] | null;
  };

  user: JWTUserData;

  // Flow-specific role flags
  isSuperAdmin: boolean;
  isClientUser: boolean;
  isDancer: boolean;
  // Every role the user can act as (one entry per professional_profiles row).
  roles: Array<{
    profileType: string;
    profileId: string;
    handle: string | null;
    onboardedAt: string | null;
  }>;
  // The role the user is currently operating as (cookie/metadata-resolved).
  activeRole: string | null;
  needsProfileSetup: boolean;
  dancerProfileSlug: string | null;
  dancerProfileId: string | null;
  clientRole: 'owner' | 'member' | null;
  clientId: string | null;
  clientMemberships: Array<{
    clientId: string;
    clientName: string;
    role: 'owner' | 'member';
  }>;
}

export const UserWorkspaceContext = createContext<UserWorkspace>(
  {} as UserWorkspace,
);

export function UserWorkspaceContextProvider(
  props: React.PropsWithChildren<{
    value: UserWorkspace;
  }>,
) {
  return (
    <UserWorkspaceContext.Provider value={props.value}>
      {props.children}
    </UserWorkspaceContext.Provider>
  );
}
